import React, {useState, useEffect} from 'react';
import {MiPerfilInferior} from './MiPerfilInferior';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {ModalesMiPerfil} from './ModalesMiPerfil';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import { Modal as M } from 'react-bootstrap';
import axios from 'axios';
import {animateScroll as scroll} from 'react-scroll';
import {useNavigate} from 'react-router-dom';

export const ContentBodyMiPerfil = (props) => {
	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [UsuarioCambiar, setUsuarioCambiar] = useState({
		...Usuario.cliente,
		email: Usuario.cliente.usuario.email,
	});
	const [FotoPerfilCambiar, setFotoPerfilCambiar] = useState();
	const [modalBorrrarCuenta, setModalBorrrarCuenta] = useState(false);
	const [modalGuardarCambios, setModalGuardarCambios] = useState(false);
	const {setGuardarCambios, setBorrarCuenta, MenuLateralAux, chageMenuLateralAux, setShowToast} = props;
	const [ModalCambiarFotoPerfil, setModalCambiarFotoPerfil] = useState(false);
	const [ModalFotoCambiadaOK, setModalFotoCambiadaOK] = useState(false);
	const [ModalFotoCambiadaNoOK, setModalFotoCambiadaNoOK] = useState(false);
	const [ErroresFormulario, setErroresFormulario] = useState([]);
	/* Creating a state variable called ModalErrores and setting it to false. */
	const [ModalErrores, setModalErrores] = useState(false);

	const [modificar, setModificar] = useState(false);

	const navigate = useNavigate();

	// const get_usuario = async () =>{
	//   await axios({
	//     method: "get",
	//     url: window.ipdirection + "clienteByCliente/",
	//     headers: {
	//       Authorization: "Bearer " + Usuario.access,
	//     },
	//   })
	//     .then((response) => {
	//       console.log('Response ',response.data[0]['usuario']['email'])
	//     })
	//     .catch((error) => {
	//       console.log(error);
	//     });
	// }

	useEffect(() => {
		scroll.scrollToTop();
		//get_usuario()
	}, []);

	const actualizarFoto = () => {
		let correct = false;
		if (FotoPerfilCambiar !== null) {
			if (FotoPerfilCambiar !== undefined) {
				if (FotoPerfilCambiar.fotoPerfil !== null) {
					if (FotoPerfilCambiar.fotoPerfil !== undefined) {
						if (
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpg' ||
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/png' ||
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpeg'
						) {
							selectFotoPerfil(Usuario, 1);
							correct = true;
						}
					}
				}
			}
		}
		if (!correct) {
			setModalFotoCambiadaNoOK(true);
		}
	};
	/**
	 * It gets the image of the user from the database and then calls the function colocarFoto()
	 * @param {Object} usuario - The user object containing the access token and user data.
	 */
	const selectFotoPerfil = (usuario, funtion) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilCliente/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {
				console.log(response, funtion);
				if (funtion === 0) {
					return colocarFoto(usuario, response.data[0]);
				} else {
					return borrarFotoAntigua(response.data[0]);
				}
			})
			.catch((error) => {
				try {
					cambiarFotoPerfil();
				} catch {
					setErroresFormulario(['Error al cargar la foto de perfil 2 ' + error]);
					setModalErrores(true);
				}
			});
	};

	const colocarFoto = (usuario, foto) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilCliente/' + foto.id.toString() + '/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
			responseType: 'blob',
		})
			.then((response) => {
				setUsuario({
					...usuario,
					fotoPerfil: URL.createObjectURL(response.data),
				});
			})
			.catch((error) => {
				setErroresFormulario(['Error al cargar la foto de perfil 1' + error.toString()]);
				setModalErrores(true);
			});
	};
	const borrarFotoAntigua = (foto) => {
		axios({
			url: window.ipdirection + 'imagenPerfilCliente/' + foto.id.toString() + '/',
			method: 'delete',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				cambiarFotoPerfil();
			})
			.catch((error) => {
				setErroresFormulario(['Fallo al actualizar su foto de perfil' + error.toString()]);
				setModalErrores(true);
			});
	};

	const cambiarFotoPerfil = () => {
		const formData = new FormData();
		const imagenOriginal = new Image(); // Crear un objeto imagen
		imagenOriginal.src = URL.createObjectURL(FotoPerfilCambiar.fotoPerfil); // Cargar la imagen en el objeto

		// Esperar a que la imagen se cargue
		imagenOriginal.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Definir la resolución deseada
			const ancho = 300; // ancho deseado
			const alto = 300; // alto deseado

			canvas.width = ancho;
			canvas.height = alto;

			// Set image scale
			let scaleFactor = Math.max(
				canvas.width / imagenOriginal.width,
				canvas.height / imagenOriginal.height
			);

			// Finding the new width and height based on the scale factor
			let newWidth = imagenOriginal.width * scaleFactor;
			let newHeight = imagenOriginal.height * scaleFactor;

			// get the top left position of the image
			// in order to center the image within the canvas
			let x = canvas.width / 2 - newWidth / 2;
			let y = canvas.height / 2 - newHeight / 2;

			ctx.drawImage(imagenOriginal, x, y, newWidth, newHeight);

			canvas.toBlob((blob) => {
				//formData.append("documento", File);
				formData.append('imagen', blob, Usuario.cliente.nombre + '.png');
				formData.append('nombre', 'FotoPerfil-' + Usuario.cliente.nombre);
				//formData.append("nombre", "Prueba");
				formData.append('usuario_id', Usuario.cliente.usuario.id);

				axios
					.post(window.ipdirection + 'imagenPerfilCliente/', formData, {
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
					})
					.then((response) => {
						selectFotoPerfil(Usuario, 0);
						setModalCambiarFotoPerfil(false);
						setModalFotoCambiadaOK(true);
					})
					.catch((error) => {
						setErroresFormulario([
							'Error al enviar la foto de perfil' + error.toString(),
						]);
						setModalErrores(true);
					});
			});
		};
	};
	const onInputChange = (event) => {
		setUsuarioCambiar({
			...UsuarioCambiar,
			[event.target.name]: event.target.value,
		});
	};

	const guardarCambios = async () => {
		console.log(Usuario.cliente.usuario['id']);

		try {
			await axios({
				method: 'put',
				url: `${window.ipdirection}modificarUsuario/${Usuario.cliente.usuario.id}/`,
				headers: {
					Authorization: `Bearer ${Usuario.access}`,
				},
				data: UsuarioCambiar,
			});

			// Actualizar el estado global de Usuario
			const updatedUsuario = {
				...Usuario,
				cliente: {
					...UsuarioCambiar,
					usuario: {
						...Usuario.cliente.usuario,
						email: UsuarioCambiar.email,
					},
				},
			};

			setUsuario(updatedUsuario); // 👈 importante
			setModalGuardarCambios(false);
			setModificar(false);
			setShowToast(true);

			// Desactivar inputs
			document.querySelectorAll('.inputModificar').forEach((input) => {
				input.disabled = true;
			});
		} catch (error) {
			console.error("Error al guardar cambios:", error);
		}
	};

	const eliminarPerfil = () => {
		axios({
			method: 'delete',
			url: window.ipdirection + 'eliminarUsuario/' + UsuarioCambiar.usuario['id'] + '/',
		})
			.then((response) => {
				// Actualiza el estado de ListaCategorias con los datos de las categorías obtenidas.
				setModalBorrrarCuenta(false);
				navigate('/login');
				setUsuario({
					tipo: 'noRegistrado',
					userName: '',
					email: '',
					imagen: '',
					access: '',
					refresh: '',
				});
			})
			.catch((error) => {});
	};

	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<>
			<MenuLateralAB
				seleccionado={11}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='container my-5'>
				<div className='miPerfilSuperior container mt-4 p-4 rounded shadow-sm justify-content-between'>
					<div className='d-flex justify-content-between w-full align-items-center flex-wrap gap-3'>
						<div className='position-relative'>
							<img
								src={Usuario?.fotoPerfil || 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images'}
								className="rounded-circle border border-success"
								style={{ width: '100px', height: '100px', objectFit: 'cover' }}
								alt={Usuario.cliente.nombre + ' ' + Usuario.cliente.apellidos}
							/>
							<div
								className="position-absolute bottom-0 end-0 bg-success rounded-circle p-1 text-white"
								style={{ cursor: 'pointer' }}
								onClick={() => setModalCambiarFotoPerfil(true)}
							>
								<i className="bi bi-plus-circle-fill centrador"></i>
							</div>
						</div>
						<h5 className="mb-0">
							{Usuario.cliente.nombre + ' ' + Usuario.cliente.apellidos}
						</h5>
					</div>
					<div className="position-relative">
						{/* Icono de engranaje (botón para abrir/cerrar menú) */}
						<div className="text-end">
							<button
								type="button"
								className="btn btn-light border-0 shadow-sm align-items-center"
								onClick={() => setMenuOpen(!menuOpen)}
								aria-label="Abrir ajustes"
							>
								<i className="bi bi-gear-fill fs-4 text-secondary"></i>
							</button>
						</div>

						{/* Menú desplegable */}
						{menuOpen && (
							<div
							className="dropdown-menu show p-3 shadow position-absolute end-0 mt-2"
							style={{ minWidth: '220px' }}
							>
							{/* Botón Modificar / Cancelar */}
							<button
								id="buttonGuardarFormUsu"
								className={`btn w-100 mb-2 ${modificar ? 'btn-outline-secondary' : 'btn-outline-primary'}`}
								onClick={() => setModificar(!modificar)}
							>
								{modificar ? 'Cancelar' : 'Modificar datos'}
							</button>

							{/* Botón Borrar cuenta */}
							<button
								className="btn btn-outline-danger w-100"
								onClick={() => setModalBorrrarCuenta(true)}
							>
								Borrar cuenta
							</button>
							</div>
						)}
					</div>
				</div>
				<MiPerfilInferior
					onInputChange={onInputChange}
					modalBorrrarCuenta={modalBorrrarCuenta}
					setModalBorrrarCuenta={setModalBorrrarCuenta}
					modificar={modificar}
					setModificar={setModificar}
					setModalGuardarCambios={setModalGuardarCambios}
					UsuarioCambiar={UsuarioCambiar}
				/>
				{
					modificar &&
					<div className='flex justify-content-end'>
						<button className='btn login-boton' onClick={() => {setModalGuardarCambios(true)}} >Guardar cambios</button>
					</div>
				}
				<ModalesMiPerfil
					modalBorrrarCuenta={modalBorrrarCuenta}
					setModalBorrrarCuenta={setModalBorrrarCuenta}
					setModalGuardarCambios={setModalGuardarCambios}
					modalGuardarCambios={modalGuardarCambios}
					guardarCambios={guardarCambios}
					eliminarPerfil={eliminarPerfil}
				/>
			</div>

			<M
				centered={true}
				show={ModalFotoCambiadaNoOK}
			>
				<M.Header>
					<div className='titulo-modal'>Mi Empresa</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						Ups... Parece que no se puede subir la foto
					</div>
				</M.Body>
				<M.Footer>
					<div className='centradorRight'>
						<button
							className='btn login-boton'
							onClick={() => setModalFotoCambiadaNoOK(false)}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalCambiarFotoPerfil}
			>
				<M.Header>
					<div className='titulo-modal'>Actualiza la imagen de tu perfil empresarial</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						<p>Sube una nueva foto para darle un aspecto más moderno y profesional a tu perfil.</p>
						<input
							type='file'
							className='form-control text-dark'
							accept='image/*'
							onChange={(e) =>
								setFotoPerfilCambiar({
									...setFotoPerfilCambiar,
									fotoPerfil: e.target.files[0],
								})
							}
						/>
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<button
							className='btn outline-boton'
							onClick={() => setModalCambiarFotoPerfil(false)}
						>
							<b>Cancelar</b>
						</button>
						<button
							className='btn login-boton'
							onClick={() => actualizarFoto()}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalFotoCambiadaOK}
			>
				<M.Header>
					<div className='titulo-modal'>Mi Empresa</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						¡Tu foto de perfil de ha sido actualizada correctamente!
					</div>
				</M.Body>
				<M.Footer>
					<div className='centradorRight'>
						<button
							className='btn login-boton'
							onClick={() => setModalFotoCambiadaOK(false)}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>
			<M
				centered={true}
				show={ModalErrores}
			>
				<M.Header>
					<div className='titulo-modal'>
						Uno o varios datos del formulario de registro no son validos
					</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						{ErroresFormulario.map((error) => (
							<div> - {error} </div>
						))}
					</div>
				</M.Body>
				<M.Footer>
					<div className='button-modal-registroEmpresa centrador'>
						<button
							className='btn login-boton'
							onClick={() => {
								setModalErrores(false);
								setErroresFormulario([]);
							}}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>
		</>
	);
};
